import { ACTIONS } from '../../modules/constants';
import precise from '../../modules/precise';
import getFastTitleDropdownOptions from '../../modules/getFastTitleDropdownOptions';
import getLemonLawDropdownOptions from '../../modules/getLemonLawDropdownOptions';

const SET_SELECTED_TITLE_VALUE = 'fcr/titlefees/SET_SELECTED_TITLE_VALUE';
const SET_LIEN_FEE = 'fcr/titlefees/SET_LIEN_FEE';
const SET_LEMON_LAW_FEE = 'fcr/titlefees/SET_LEMON_LAW_FEE';
const SET_LATE_FEE = 'fcr/titlefees/SET_LATE_FEE';
const SET_FAST_TITLE_FEE = 'fcr/titlefees/SET_FAST_TITLE_FEE';
const RESET_TITLE_FEES = 'fcr/titlefees/RESET_TITLE_FEES';

const INITIAL_STATE = {
  selectedTitleValue: '',
  titleFee: '0.00',
  lienFee: '0.00',
  lienFeeSelectedValue: '',
  lienFeeSelectedValueLabel: 'Lien Fee', // default for print
  fastTitleFee: '0.00',
  fastTitleFeeSelectedValue: '',
  fastTitleFeeSelectedValueLabel: 'Fast Title Fee', // default for print
  lateFee: '0.00',
  lateFeeSelectedValue: '',
  lateFeeSelectedValueLabel: 'Late Fee', // default for print
  lemonLawFeeSelectedValue: '',
  lemonLawFeeSelectedValueLabel: 'Lemon Law Fee', // default for print
  lemonLawFee: '0.00',
  titleLabel: '',
  titleType: null,

  // This will hold John's global variables:
  // `t0, t1, t2, t3, t4` so that they can be
  // used to help set the titlefee dropdown components.
  // I hate this, but you gotta do what you gotta do, right?
  // ¯\_(ツ)_/¯
  selectedTitleVariables: {},

  mobileHomeLength: 1, // 1 2 or 3 (Single/Double/Triple-wide)
};

export default function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case ACTIONS.RESET:
    case ACTIONS.RESET_ALL_EXCEPT_MONTH:
    case ACTIONS.TOGGLE_SHOULD_CHARGE_BRANCH_FEE:
    case ACTIONS.TOGGLE_SHOULD_CHARGE_VESSEL_COUNTY_FEE:
    case RESET_TITLE_FEES:
      return {
        ...INITIAL_STATE,
      };
    case SET_SELECTED_TITLE_VALUE:
      return {
        ...state,
        selectedTitleValue: action.selectedValue,
        titleFee: action.fee,
        selectedTitleVariables: { ...action.titleVariables },
        titleLabel: action.titleLabel,
        titleType: action.titleType,
        // This will simply force the default Title By Mail and LemonLaw option
        // to appear in the overall calculation. Not pretty, but effective for now.
        // ¯\_(ツ)_/¯
        fastTitleFee: precise(getFastTitleDropdownOptions({ selectedTitleVariables: action.titleVariables, selectedTitleValue: action.selectedValue })[0][1]),
        lemonLawFee: precise(getLemonLawDropdownOptions({ selectedTitleVariables: action.titleVariables, selectedTitleValue: action.selectedValue })[0][1]),
      };
    case SET_LIEN_FEE:
      return {
        ...state,
        lienFee: action.fee,
        lienFeeSelectedValue: action.selectedValue,
        lienFeeSelectedValueLabel: action.selectedValueLabel,
      };
    case SET_FAST_TITLE_FEE:
      return {
        ...state,
        fastTitleFee: action.fee,
        fastTitleFeeSelectedValue: action.selectedValue,
        fastTitleFeeSelectedValueLabel: action.selectedValueLabel,
      };
    case SET_LATE_FEE:
      return {
        ...state,
        lateFee: action.fee,
        lateFeeSelectedValue: action.selectedValue,
        lateFeeSelectedValueLabel: action.selectedValueLabel,
      };
    case SET_LEMON_LAW_FEE:
      return {
        ...state,
        lemonLawFee: action.fee,
        lemonLawFeeSelectedValue: action.selectedValue,
        lemonLawFeeSelectedValueLabel: action.selectedValueLabel,
      };
    case ACTIONS.SET_MOBILE_HOME_LENGTH:
      return {
        ...state,
        mobileHomeLength: action.length,
      };
    default:
      return state;
  }
}

export function setSelectedTitleValue(fee, selectedValue, titleVariables, titleLabel, titleType) {
  return {
    type: SET_SELECTED_TITLE_VALUE,
    fee,
    selectedValue,
    titleVariables,
    titleLabel,
    titleType,
  };
}

export function setLienFee(fee, selectedValue, selectedValueLabel) {
  return {
    type: SET_LIEN_FEE,
    fee,
    selectedValue,
    selectedValueLabel,
  };
}

export function setLateFee(fee, selectedValue, selectedValueLabel) {
  return {
    type: SET_LATE_FEE,
    fee,
    selectedValue,
    selectedValueLabel,
  };
}

export function setLemonLawFee(fee, selectedValue, selectedValueLabel) {
  return {
    type: SET_LEMON_LAW_FEE,
    fee,
    selectedValue,
    selectedValueLabel,
  };
}

export function setFastTitleFee(fee, selectedValue, selectedValueLabel) {
  return {
    type: SET_FAST_TITLE_FEE,
    fee,
    selectedValue,
    selectedValueLabel,
  };
}

export function resetTitleFees() {
  return {
    type: RESET_TITLE_FEES,
  };
}

export function setMobileHomeLength(length) {
  return {
    type: ACTIONS.SET_MOBILE_HOME_LENGTH,
    length: Number(length),
  };
}



// WEBPACK FOOTER //
// ./src/redux/modules/titlefees.js